import { createuuid } from '@/js/utils'
import { SUCCESS_CODE } from '@/service/httpCode'
export default {
    watch: {
        '$route.query': {
            handler: function () {
                this.pageId = createuuid()
                this.params = this.$route ? this.$route.query : {}
            },
            immediate: true
        }
    },
    methods: {
        async showTheLoading(callback, isLoading) {
            isLoading && (this[isLoading] = true)
            this.$vux.loading.show()
            await callback()
            this.$vux.loading.hide()
            isLoading && (this[isLoading] = false)
        },
        sendRecord(key, value = '') {
            const { appId, userId, bizCode, orderNo } = this.$store
            this.$http.sendRecord({
                orderNum: orderNo,
                bizCode,
                appId,
                userId,
                eventKey: key,
                eventValue: value,
                pageId: this.pageId
            })
        },
        doSensors(params) {
            Sensors.track('h5_element_imp', params)
        },
        async doRequest(methodName, params) {
            return new Promise(async (resolve, reject) => {
                const { result, data } = await this.$http[methodName](params)
                if (result === SUCCESS_CODE) {
                    resolve(data)
                } else {
                    reject(result)
                }
            })
        },
        recordSensorsLog(log) {
            this.doSensors({
                page: 'paycash页',
                tgt_event_id: 'h5_syt_998',
                tgt_name: log,
                url: location.href
            })
        },
        sensorsTrack(eventType, params) {
            Sensors.track(eventType, params)
        },
        sensorsRecord(eventType, params) {
            try {
                const { appId, userId, bizCode, orderNo } = this.$store;
                Sensors.track(eventType, Object.assign(params, {
                    param: bizCode,
                    param1: orderNo,
                    param2: userId,
                    param3: appId
                }));
            } catch (e) {
                console.log(e)
            }
        }
    }
}
